import UserInfoActions from '../../../../actions/UserInfoActions';
import store from '../../../../stores/redux';
import AppConstants from '../../../../constants/AppConstants';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';

const reportUtils = ReportComponent.utils;

const { dispatch } = store;
const actions = {
    saveStateServerStorage(store) {
        dispatch({
            type  : AppConstants.SERVER_STORAGE_SUCCESS,
            items : store
        });
    },

    saveServerStorage(metrics) {
        const storeServerStorage = store.getState().serverStorage.store;
        const metricsString = Array.isArray(metrics) ? reportUtils.getStrMetric(metrics) : metrics;
        
        let newStoreServerStorage = {
            ...storeServerStorage,
            report: {
                ...storeServerStorage.report,
                metrics: metricsString
            }
        };
        
        actions.saveStateServerStorage(newStoreServerStorage);
        
        return UserInfoActions.setServerStorage()
            .then(() => {
                console.log('Metrics saved successfully, data refreshed');
                const updatedStore = store.getState().serverStorage.store;
                console.log('Updated serverStorage.store after save:', updatedStore);
            })
            .catch((error) => {
                console.error('Failed to save metrics:', error);
            });
    },
};

export default actions;
